export const downloadFile = (url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.download = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBlob = (blob: Blob, filename: string) => {
  // Create a download link and trigger the download
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();

  // Release the object URL after the download
  URL.revokeObjectURL(url);
};

export const getImageBuffer = async (src: string) => {
  const response = await fetch(src);
  return response.arrayBuffer();
};
